import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { MatterPropertyType } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { TestHooks } from './parcel-of-tied-land-form.hooks';

@UntilDestroy()
@Component({
	selector: 'app-parcel-of-tied-land-form',
	templateUrl: './parcel-of-tied-land-form.component.html',
	animations: [openClose()],
	standalone: false,
})
export class ParcelOfTiedLandFormComponent implements OnInit {
	testHooks = TestHooks;
	@Select(SelectedMatter.propertyType)
	propertyType$: Observable<MatterPropertyType>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	@Output() onFormSubmit = new EventEmitter<boolean>();
	@Output() onCancel = new EventEmitter<boolean>();
	@Input() showCancelBtn: boolean = true;

	public propertyType: MatterPropertyType;

	public ICON = ICON;

	constructor(private matterDispatch: MatterDispatch) {}

	ngOnInit() {
		this.propertyType$
			.pipe(untilDestroyed(this), take(1))
			.subscribe((propertyType) => {
				this.propertyType = cloneDeep(propertyType);

				if (!this.propertyType?.condoPlan) {
					this.propertyType.condoPlan =
						'Ontario Common Elements Condominium Plan No.';
				}
			});
	}

	onSubmit(form: NgForm) {
		if (form.valid) {
			this.matterDispatch.SetPropertyType(this.matterId, {
				condoPlan: this.propertyType.condoPlan,
				percentageInterest: this.propertyType.percentageInterest,
				commonExpenses: this.propertyType.commonExpenses,
			});

			this.onFormSubmit.emit(true);
		}
	}

	onCancelClick() {
		this.onCancel.emit(true);
	}
}
